export const readOnlyTokenUtil = {
  fetch: (): string | undefined => {
    const url = new URL(window.location.href);
    return url.searchParams.get("readOnlyToken") ?? undefined;
  },
};
